import { gql } from '@urql/core';
import React from 'react';
import {
    ParentMyPlayersFieldsFragment,
    ParentMyPlayersFieldsOnRemoveCallbackFragment,
} from '../../../../generated/spin-graphql';
import { EditableMyPlayerCard } from './EditableMyPlayerCard';

type Props = {
    players: ParentMyPlayersFieldsFragment[];
    onRemove: (player: ParentMyPlayersFieldsOnRemoveCallbackFragment) => void;
};

gql`
    fragment ParentMyPlayersFields on espin_player_profile {
        id
        ...EditableMyPlayerCard
    }

    fragment ParentMyPlayersFieldsOnRemoveCallback on espin_player_profile {
        id
        first_name
        last_name
    }
`;

export const ParentMyPlayersFields: React.FC<Props> = ({ players, onRemove }) => {
    return (
        <>
            <h2 className="form-heading">My Players</h2>
            <div className="my-players">
                {players.map((player, index) => (
                    <EditableMyPlayerCard
                        key={`editable-my-player-card-${index}`}
                        player={player}
                        canRemove={players.length > 1}
                        onRemove={() => onRemove(player)}
                    />
                ))}
            </div>
        </>
    );
};
